<app-document-countries
  [name]="'Политика конфиденциальности'"
  [countries]="countries"
></app-document-countries>
